<template>
  <SfButtonBase
    :variant="variant"
    :small="small"
    :disabled="disabled"
    v-bind="$attrs"
    component-type="text"
    @click="handleClick"
  >
    <slot></slot>
  </SfButtonBase>
</template>
<script setup lang="ts">
import SfButtonBase from './sf-button-base.vue'

defineOptions({
  name: 'SfButtonText',
})

interface Props {
  variant?: string
  small?: boolean
  disabled?: boolean
}

withDefaults(defineProps<Props>(), {
  variant: 'primary',
  small: false,
  disabled: false,
})

const emit = defineEmits(['click'])

function handleClick(): void {
  emit('click')
}
</script>
